var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper",staticStyle:{"position":"absolute"}},[_c('ul',{staticClass:"menuBody"},_vm._l((_vm.menuList),function(item,index){return _c('li',{key:index,class:{ active: _vm.menuIndex == index },on:{"click":function($event){return _vm.menuFn(index)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }